import type { components } from "@appretio/api";

export type EventCalendarEntry = components["schemas"]["EventChartDataEntry"];

export interface EventChartDataPoint {
  fiscalYear: string;
  activationType: string;
  activationName: string;
  /** Original date from the APi — used by the tooltip to display the real calendar year. */
  dateFrom: string;
  /** Original date from the API — used by the tooltip to display the real calendar year. */
  dateTo: string;
  /** Year-normalized (2000) copy of dateFrom — used for Y-axis positioning so all fiscal years overlay. */
  chartDateFrom: Date;
  /** Year-normalized (2000 or 2001 for year-boundary events) copy of dateTo. */
  chartDateTo: Date;
}

export const COLOR_MAP: Record<string, string> = {
  promo: "hsla(217, 91%, 60%, 1)",
  sale: "hsla(25, 95%, 53%, 1)",
  holiday: "hsla(142, 71%, 45%, 1)",
  email: "hsla(271, 91%, 65%, 1)"
};

export const FALLBACK_COLOR = "hsla(215, 20%, 65%, 1)";

export const TYPE_LABELS: Record<string, string> = {
  holiday: "Holidays",
  sale: "Sales",
  promo: "Promos",
  email: "Emails"
};
